import { render, staticRenderFns } from "./BrandProduct.vue?vue&type=template&id=c210f6c2&scoped=true&"
import script from "./BrandProduct.vue?vue&type=script&lang=js&"
export * from "./BrandProduct.vue?vue&type=script&lang=js&"
import style0 from "./BrandProduct.vue?vue&type=style&index=0&id=c210f6c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c210f6c2",
  null
  
)

export default component.exports